export class DocsChatbotMessagesPairExtractor {
  extract(chatMessages, { maxPairs = 3 } = {}) {
    if (!Array.isArray(chatMessages) || maxPairs < 1) return [];

    const completePairs = [];

    for (let i = 0; i < chatMessages.length - 1; i++) {
      const userMessage = chatMessages[i];
      const botMessage = chatMessages[i + 1];

      if (userMessage?.sender !== "user" || botMessage?.sender !== "bot")
        continue;

      const question =
        typeof userMessage.text === "string" ? userMessage.text.trim() : "";
      const answer =
        typeof botMessage.text === "string" ? botMessage.text.trim() : "";

      const botConsideredComplete =
        botMessage?.isDone === true ||
        (botMessage?.isTyping !== true && answer.length > 0);

      if (!question || !answer) continue;
      if (!botConsideredComplete) continue;

      completePairs.push([question, answer]);

      // Skip the bot message we just paired.
      i += 1;
    }

    const lastPairs = completePairs.slice(-maxPairs);
    return lastPairs.flat();
  }
}
